module.exports = __webpack_public_path__ + "static/media/p508.b57a6c66.jpg";